<template>
    <div class="group-detail app">
        <div class="top-box tc">
            <p class="title fs16 color-blank pb8">{{data.post}}</p>
            <p class="campus fs14 pb8 color-blue" v-if="data.type==1">{{data.group_name}}</p>
            <p class="campus fs14 pb8 color-blue" v-else>{{data.hospital_name}}</p>
            <p :class="timeCss"><span class="time color-gray">{{formatTime.getMsecToSpecificTime(data.addtime,'yyyy/MM/dd hh:mm:ss')}}</span></p>
            <p :class="authorCss" v-if="data.author"><span class="time color-gray">作者：{{data.author}}</span></p>
            <p class="pb16 fs12" v-if="data.source"><span class="time color-gray">来源：{{data.source}}</span></p>
        </div>
        <div class="quill-editor">
            <div class="ql-container ql-snow">
                <div class="ql-editor editor pre-wrap" v-html="data.content"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        
    },
    data() {
        return {
            data:{},
            timeCss: 'pb16 fs12',
            authorCss: 'pb16 fs12',
        };
    },
    computed: {

    },
    created() {
        this.$axios.post(this.api.recruit.detail,{id:this.$route.params.id},res =>{
            this.data=res.data;

            if(this.data.author || this.data.source){
                this.timeCss = 'pb8 fs12';
            }

            if(this.data.source){
                this.authorCss = 'pb8 fs12';
            }
        },err =>{
            this.data={};
        })
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        
    },
};
</script>
<style scoped>
.group-detail{height:100%;background:#fff;padding:16px 16px 0;}
.editor{
    border-top:1px solid #EBEBED;
    box-shadow:none;
}
</style>


// WEBPACK FOOTER //
// src/view/jobOffers/detail.vue